import axios from "axios";
import i18n from "../../i18n";

const actions = {
  bulkDeleteProofs(context, ids) {
    return axios
      .post("proof/bulk-delete", { ids })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.bulk.deletedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  bulkMoveProofs(context, { ids, category }) {
    return axios
      .post("proof/bulk-move", { ids, category })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.bulk.movedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getAllProofs(context, params) {
    return axios
      .get("proof", { params })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getProofMonthlyStats(context, year) {
    return axios
      .get("proof/monthlyStats", { params: year ? { year } : {} })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getProofsByMonth(context, { year, month }) {
    return axios
      .get("proof/byMonth", { params: { year, month } })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getSingleProof(context, id) {
    return axios
      .get("proof/" + id)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  createProof(context, value) {
    return axios
      .post("proof", value)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.createdMessage", { name: r.data.name }));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateProof(context, value) {
    return axios
      .put("proof/" + value.id, value)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.updatedMessage", { name: r.data.name }));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteProof(context, value) {
    return axios
      .delete("proof/" + value.id)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.deletedMessage"));
        return r;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  logProof(context, { id, date, completedTasks }) {
    return axios
      .post("proof/" + id + "/log", {
        ...(date ? { date } : {}),
        ...(completedTasks ? { completedTasks } : {}),
      })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.loggedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  uploadProofDocument(context, { id, content, name, filetype, historyIndex }) {
    return axios
      .post("proof/" + id + "/document", { content, name, filetype, historyIndex })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateProofer(context, { id, proofer }) {
    return axios
      .put("proof/" + id + "/proofer", proofer)
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("proof.prooferUpdatedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getProofDocumentUrl(context, { proofId, location, filetype }) {
    return axios
      .get(`proof/${proofId}/document`, { params: { location, filetype } })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  moveProof(context, { id, category }) {
    return axios
      .put("proof/" + id, { category })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
